module.exports = __webpack_public_path__ + "img/Listening.71d7ebc2.svg";